import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const OliDetailModal = ({ oli, onClose, onConsult }) => {
  if (!oli) return null;

  const formatPrice = (price) => {
    return new Intl.NumberFormat('id-ID', {
      style: 'currency',
      currency: 'IDR',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    })?.format(price);
  };

  const handlePesanDenganService = (oli) => {
    const phoneNumber = "6288293642972"; 
    const message = `
      Halo Honda Berdikari Pamulang 👋

      Saya tertarik dengan produk:
      Nama Produk : ${oli?.name}
      Kategori    : ${oli?.category || "-"}
      Harga       : Rp ${oli?.price?.toLocaleString("id-ID")}

      saya ingin memesan produk tersebut bersamaan dengan service motor saya.

      Mohon info:
      - Ketersediaan produk
      - Jadwal service terdekat

      Terima kasih 🙏
    `;

    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, "_blank");
  };


  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-secondary/80 backdrop-blur-sm">
      <div className="bg-card rounded-lg max-w-4xl w-full max-h-[90vh] overflow-y-auto shadow-honda-glow">
        <div className="sticky top-0 bg-card border-b border-border p-4 md:p-6 flex items-center justify-between z-10">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground">
            Detail Produk
          </h2>
          <button
            onClick={onClose}
            className="w-10 h-10 rounded-lg hover:bg-muted flex items-center justify-center transition-colors"
            aria-label="Close modal"
          >
            <Icon name="X" size={24} color="var(--color-foreground)" />
          </button>
        </div>

        <div className="p-4 md:p-6 lg:p-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-8">
            <div className="space-y-4">
              <div className="relative h-64 md:h-80 lg:h-96 rounded-lg overflow-hidden bg-muted">
                <Image
                  src={oli?.image}
                  alt={oli?.imageAlt}
                  className="w-full h-full object-cover"
                />
                {oli?.isGenuine && (
                  <div className="absolute top-4 left-4 bg-primary text-primary-foreground px-4 py-2 rounded-full flex items-center space-x-2 shadow-honda-subtle">
                    <Icon name="Shield" size={18} />
                    <span className="text-sm font-heading font-bold">Genuine Honda</span>
                  </div>
                )}
              </div>

              {oli?.additionalImages && oli?.additionalImages?.length > 0 && (
                <div className="grid grid-cols-4 gap-2">
                  {oli?.additionalImages?.map((img, index) => (
                    <div key={index} className="h-20 rounded-lg overflow-hidden bg-muted">
                      <Image
                        src={img?.url}
                        alt={img?.alt}
                        className="w-full h-full object-cover hover:scale-110 transition-transform duration-300 cursor-pointer"
                      />
                    </div>
                  ))}
                </div>
              )}
            </div>

            <div className="space-y-6">
              <div>
                <span className="text-sm text-muted-foreground font-medium">{oli?.category}</span>
                <h3 className="text-2xl md:text-3xl font-heading font-bold text-foreground mt-2">
                  {oli?.name}
                </h3>
              </div>

              <div className="flex items-center justify-between p-4 bg-muted rounded-lg">
                <div>
                  <p className="text-sm text-muted-foreground mb-1">Harga</p>
                  <p className="text-2xl md:text-3xl font-heading font-bold text-primary">
                    {formatPrice(oli?.price)}
                  </p>
                </div>
                {/* <div className="text-right">
                  <p className="text-sm text-muted-foreground mb-1">Ketersediaan</p>
                  <p className={`text-lg font-heading font-bold ${oli?.stock > 10 ? 'text-success' : oli?.stock > 0 ? 'text-warning' : 'text-error'}`}>
                    {oli?.stock > 0 ? `${oli?.stock} unit tersedia` : 'Stok habis'}
                  </p>
                </div> */}
              </div>

              <div className="space-y-4">
                <div>
                  <h4 className="text-lg font-heading font-bold text-foreground mb-2">Deskripsi</h4>
                  <p className="text-sm text-muted-foreground leading-relaxed">
                    {oli?.description}
                  </p>
                </div>

                <div className="grid grid-cols-2 gap-4">
                  <div className="p-3 bg-muted rounded-lg">
                    <div className="flex items-center space-x-2 mb-2">
                      <Icon name="Package" size={18} color="var(--color-primary)" />
                      <span className="text-xs text-muted-foreground">Kode Oli</span>
                    </div>
                    <p className="text-sm font-heading font-bold text-foreground">{oli?.oliCode}</p>
                  </div>

                  {oli?.warranty && (
                    <div className="p-3 bg-muted rounded-lg">
                      <div className="flex items-center space-x-2 mb-2">
                        <Icon name="Award" size={18} color="var(--color-primary)" />
                        <span className="text-xs text-muted-foreground">Garansi</span>
                      </div>
                      <p className="text-sm font-heading font-bold text-foreground">{oli?.warranty}</p>
                    </div>
                  )}
                </div>

                {oli?.specifications && (
                  <div>
                    <h4 className="text-lg font-heading font-bold text-foreground mb-3">Spesifikasi</h4>
                    <div className="space-y-2">
                      {oli?.specifications?.map((spec, index) => (
                        <div key={index} className="flex items-center justify-between p-3 bg-muted rounded-lg">
                          <span className="text-sm text-muted-foreground">{spec?.label}</span>
                          <span className="text-sm font-heading font-semibold text-foreground">{spec?.value}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {oli?.compatibleModels && oli?.compatibleModels?.length > 0 && (
                  <div>
                    <h4 className="text-lg font-heading font-bold text-foreground mb-3">Model Kompatibel</h4>
                    <div className="flex flex-wrap gap-2">
                      {oli?.compatibleModels?.map((model, index) => (
                        <span
                          key={index}
                          className="px-3 py-1 bg-primary/10 text-primary rounded-full text-xs font-heading font-semibold"
                        >
                          {model}
                        </span>
                      ))}
                    </div>
                  </div>
                )}
              </div>

              <div className="space-y-3 pt-4 border-t border-border">
                <Button
                  variant="default"
                  size="lg"
                  fullWidth
                  iconName="MessageCircle"
                  iconPosition="left"
                  onClick={() => onConsult(oli)}
                  disabled={oli?.stock === 0}
                >
                  Konsultasi via WhatsApp
                </Button>
                <Button
                  variant="outline"
                  size="lg"
                  fullWidth
                  iconName="Calendar"
                  iconPosition="left"
                  onClick={() => handlePesanDenganService(oli)}
                  disabled={oli?.stock === 0}
                >
                  Pesan dengan Service
                </Button>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OliDetailModal;